// Aqui os dados do head das páginas

import React from 'react'
import Helmet from 'react-helmet'
import Opengraph from '~/assets/img/Opengraph.jpg'
import { useLanguage } from '~/hooks'

function canonicalUrl(pathname: string) {
  return `https://${process.env.GATSBY_SITE_URL}${
    process.env.GATSBY_LANGUAGE === 'en'
      ? '/en'
      : process.env.GATSBY_LANGUAGE === 'es'
      ? '/es'
      : ''
  }/dvert-residence${pathname}`
}

interface Props {
  title?: string
  description?: string
  location: Location
}

const DEFAULT_TITLE = process.env.GATSBY_SITE_NAME

const Head = ({ title, description, location }: Props) => {
  const { t } = useLanguage()
  const defaultDescription = t('Head.description')

  return (
    <Helmet>
      <meta
        property="og:image"
        itemProp="image"
        content={canonicalUrl(Opengraph)}
      />
      <meta name="twitter:image" content={canonicalUrl(Opengraph)} />
      <title>{title || DEFAULT_TITLE} - Dimas Construções</title>
      <meta property="og:title" content={title || DEFAULT_TITLE} />
      <meta property="og:site_name" content="Dimas Construções" />
      <meta name="description" content={description || defaultDescription} />
      <meta
        property="og:description"
        content={description || defaultDescription}
      />
      <link rel="canonical" href={canonicalUrl(location.pathname)} />
      <meta property="og:url" content={canonicalUrl(location.pathname)} />
      <link rel="shortcut icon" href="/favicon.ico" type="image/x-icon" />
      <meta property="og:locale" content="pt_BR" />
      <meta charSet="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
    </Helmet>
  )
}

export default Head
